import React, { useState } from 'react';

function PensionGuide({ onNavigate }) {
  const [activeTab, setActiveTab] = useState('overview');

  const tabs = [
    { key: 'overview',   label: '📋 연금 제도 개요' },
    { key: 'taxbenefits', label: '💰 절세 상품 3총사' },
    { key: 'practical',  label: '🎯 실전 가이드' },
  ];

  const tabContent = {
    overview: (
      <div>
        <div className="lb-alert lb-alert-info" style={{ marginBottom: '24px' }}>
          💡 <strong>우리나라의 다층 연금 체계</strong>: 한국은 <strong>3층 구조의 연금 체계</strong>를 운영하고 있습니다.
          각 층별로 역할이 다르므로 전체적인 이해가 필요합니다.
        </div>

        <div className="lb-grid-3" style={{ marginBottom: '28px' }}>
          <div className="guide-card">
            <div className="guide-card-header guide-card-header--brown">🏛️ 1층: 국민연금</div>
            <p style={{ fontSize: '13px', fontWeight: '700', color: 'var(--color-brown-700)', marginBottom: '8px' }}>공적연금 (의무가입)</p>
            <ul style={{ paddingLeft: '18px', fontSize: '14px', color: 'var(--color-text-sub)', lineHeight: '1.9' }}>
              <li>모든 국민이 가입하는 기본 연금</li>
              <li>소득의 9% 납부 (본인 4.5%, 사업자 4.5%)</li>
              <li>국가가 운영하는 가장 안전한 연금</li>
              <li>인플레이션 보정 및 장수 리스크 보장</li>
            </ul>
            <span className="lb-badge" style={{ marginTop: '12px' }}>기초 생활 보장</span>
          </div>

          <div className="guide-card">
            <div className="guide-card-header guide-card-header--caramel">💼 2층: 퇴직연금</div>
            <p style={{ fontSize: '13px', fontWeight: '700', color: 'var(--color-brown-700)', marginBottom: '8px' }}>기업연금 (의무가입)</p>
            <ul style={{ paddingLeft: '18px', fontSize: '14px', color: 'var(--color-text-sub)', lineHeight: '1.9' }}>
              <li>DB형: 회사가 약속한 금액 지급</li>
              <li>DC형: 개인이 운용, 결과에 따라 변동</li>
              <li>IRP: 개인형 퇴직연금계좌</li>
              <li>연간 300만원 세액공제 혜택</li>
            </ul>
            <span className="lb-badge" style={{ marginTop: '12px' }}>적정 생활 보장</span>
          </div>

          <div className="guide-card">
            <div className="guide-card-header guide-card-header--latte">🐷 3층: 개인연금</div>
            <p style={{ fontSize: '13px', fontWeight: '700', color: 'var(--color-brown-700)', marginBottom: '8px' }}>사적연금 (선택가입)</p>
            <ul style={{ paddingLeft: '18px', fontSize: '14px', color: 'var(--color-text-sub)', lineHeight: '1.9' }}>
              <li>연금저축: 연간 600만원 세액공제</li>
              <li>ISA: 개인종합자산관리계좌</li>
              <li>개인적으로 준비하는 추가 노후자금</li>
              <li>투자 상품 선택의 자유도 높음</li>
            </ul>
            <span className="lb-badge" style={{ marginTop: '12px' }}>풍요로운 노후</span>
          </div>
        </div>

        <div className="lb-soft-panel lb-card-padded">
          <h3 className="lb-title-md" style={{ marginBottom: '16px' }}>📊 노후 준비의 현실</h3>
          <p className="lb-body" style={{ marginTop: 0 }}>
            일반적으로 노후에는 현역 시절 소득의 <strong>70–80%</strong> 정도가 필요합니다.
            하지만 국민연금만으로는 약 <strong>40%</strong>만 보장됩니다.
          </p>
          <div className="lb-grid-3">
            <div style={{ textAlign: 'center', padding: '16px', background: 'rgba(255,255,255,0.7)', borderRadius: 'var(--radius-md)' }}>
              <div style={{ fontSize: '28px', fontWeight: '900', color: 'var(--color-brown-700)' }}>40%</div>
              <div style={{ fontSize: '13px', color: 'var(--color-text-sub)', fontWeight: '700' }}>국민연금</div>
            </div>
            <div style={{ textAlign: 'center', padding: '16px', background: 'rgba(255,255,255,0.7)', borderRadius: 'var(--radius-md)' }}>
              <div style={{ fontSize: '28px', fontWeight: '900', color: 'var(--color-brown-600)' }}>20%</div>
              <div style={{ fontSize: '13px', color: 'var(--color-text-sub)', fontWeight: '700' }}>퇴직연금</div>
            </div>
            <div style={{ textAlign: 'center', padding: '16px', background: 'rgba(255,255,255,0.7)', borderRadius: 'var(--radius-md)' }}>
              <div style={{ fontSize: '28px', fontWeight: '900', color: 'var(--color-caramel)' }}>10~20%</div>
              <div style={{ fontSize: '13px', color: 'var(--color-text-sub)', fontWeight: '700' }}>개인연금 (부족분)</div>
            </div>
          </div>
          <p className="lb-card-desc" style={{ marginTop: '16px', textAlign: 'center' }}>
            개인연금과 퇴직연금을 통한 추가 준비가 필수적입니다.
          </p>
        </div>
      </div>
    ),

    taxbenefits: (
      <div>
        <div className="lb-alert lb-alert-success" style={{ marginBottom: '24px' }}>
          💰 <strong>세액공제로 노후자금 늘리기</strong>: 연금저축, IRP, ISA를 활용하면 세금을 절약하면서 노후자금을 늘릴 수 있습니다.
          단순 적금 대비 약 <strong>1.5–2배</strong> 더 많은 자금을 만들 수 있습니다.
        </div>

        <div className="lb-grid-3" style={{ marginBottom: '28px' }}>
          <div className="guide-card">
            <div className="guide-card-header guide-card-header--brown">🐷 연금저축</div>
            <span className="lb-badge" style={{ marginBottom: '12px' }}>연간 최대 600만원</span>
            <h4 style={{ fontSize: '14px', fontWeight: '800', color: 'var(--color-brown-800)', marginBottom: '8px' }}>특징</h4>
            <ul style={{ paddingLeft: '18px', fontSize: '14px', color: 'var(--color-text-sub)', lineHeight: '1.9' }}>
              <li>누구나 가입 가능</li>
              <li>세액공제 600만원</li>
              <li>과세이연 효과</li>
              <li>5년 의무가입</li>
            </ul>
            <h4 style={{ fontSize: '14px', fontWeight: '800', color: 'var(--color-brown-800)', margin: '12px 0 8px' }}>수령 시 세율</h4>
            <ul style={{ paddingLeft: '18px', fontSize: '13px', color: 'var(--color-text-muted)', lineHeight: '1.9' }}>
              <li>55세 이후: 연금소득세 3.3–5.5%</li>
              <li>중도해지: 기타소득세 16.5%</li>
            </ul>
          </div>

          <div className="guide-card">
            <div className="guide-card-header guide-card-header--caramel">💼 IRP</div>
            <span className="lb-badge" style={{ marginBottom: '12px' }}>연간 최대 300만원</span>
            <h4 style={{ fontSize: '14px', fontWeight: '800', color: 'var(--color-brown-800)', marginBottom: '8px' }}>특징</h4>
            <ul style={{ paddingLeft: '18px', fontSize: '14px', color: 'var(--color-text-sub)', lineHeight: '1.9' }}>
              <li>소득 있는 누구나</li>
              <li>퇴직금 이체 필수</li>
              <li>안전자산 30% 의무</li>
            </ul>
            <h4 style={{ fontSize: '14px', fontWeight: '800', color: 'var(--color-brown-800)', margin: '12px 0 8px' }}>세액공제 조건</h4>
            <ul style={{ paddingLeft: '18px', fontSize: '13px', color: 'var(--color-text-muted)', lineHeight: '1.9' }}>
              <li>연금저축과 합산 최대 900만원</li>
              <li>총급여 5,500만원 이하: 16.5%</li>
              <li>총급여 5,500만원 초과: 13.2%</li>
            </ul>
          </div>

          <div className="guide-card">
            <div className="guide-card-header guide-card-header--latte">📈 ISA</div>
            <span className="lb-badge" style={{ marginBottom: '12px' }}>연간 최대 2,000만원</span>
            <h4 style={{ fontSize: '14px', fontWeight: '800', color: 'var(--color-brown-800)', marginBottom: '8px' }}>특징</h4>
            <ul style={{ paddingLeft: '18px', fontSize: '14px', color: 'var(--color-text-sub)', lineHeight: '1.9' }}>
              <li>만 19세 이상 가능</li>
              <li>국내주식 매매차익 비과세</li>
              <li>손익통산 가능</li>
              <li>3년 의무가입</li>
            </ul>
            <h4 style={{ fontSize: '14px', fontWeight: '800', color: 'var(--color-brown-800)', margin: '12px 0 8px' }}>비과세 한도</h4>
            <ul style={{ paddingLeft: '18px', fontSize: '13px', color: 'var(--color-text-muted)', lineHeight: '1.9' }}>
              <li>일반형: 연간 200만원</li>
              <li>서민형: 연간 400만원</li>
              <li>초과분: 9.9% 분리과세</li>
            </ul>
          </div>
        </div>

        <div className="lb-soft-panel lb-card-padded">
          <h3 className="lb-title-md" style={{ marginBottom: '16px' }}>🗺️ 가입 우선순위 가이드</h3>
          <div className="lb-framework-steps" style={{ borderRadius: 'var(--radius-md)', overflow: 'hidden', border: '1px solid var(--color-border-light)' }}>
            <div className="lb-step">
              <div className="lb-step-number">01</div>
              <div className="lb-step-title" style={{ fontSize: '18px' }}>ISA 가입</div>
              <p className="lb-card-desc">주식투자를 하고 있다면 가장 먼저! 국내주식 매매차익 비과세 혜택</p>
            </div>
            <div className="lb-step">
              <div className="lb-step-number">02</div>
              <div className="lb-step-title" style={{ fontSize: '18px' }}>연금저축</div>
              <p className="lb-card-desc">세액공제가 필요하고 노후대비 의지가 있다면. 연간 600만원 한도</p>
            </div>
            <div className="lb-step">
              <div className="lb-step-number">03</div>
              <div className="lb-step-title" style={{ fontSize: '18px' }}>IRP 추가납입</div>
              <p className="lb-card-desc">연금저축 600만원 채우고도 여유자금이 있다면. 연간 300만원 추가</p>
            </div>
          </div>
        </div>
      </div>
    ),

    practical: (
      <div>
        <div className="lb-alert lb-alert-info" style={{ marginBottom: '24px' }}>
          🚀 <strong>지금 당장 할 수 있는 Action Plan</strong>: 연금과 절세에 대해 배웠다면, 이제 실제로 행동에 옮겨야 합니다.
          단계별로 차근차근 진행해보세요.
        </div>

        <div className="lb-grid-2" style={{ marginBottom: '28px' }}>
          <div className="guide-card">
            <div className="guide-card-header guide-card-header--brown">📋 Step 1: 현황 파악</div>
            <ul style={{ paddingLeft: '0', listStyle: 'none', fontSize: '14px', color: 'var(--color-text-sub)', lineHeight: '1' }}>
              {[
                { label: '국민연금 예상 수령액 확인', hint: '국민연금 홈페이지 → 내 연금 알아보기' },
                { label: '퇴직연금 종류 확인', hint: 'DB형 vs DC형 vs IRP 중 어느 것인지' },
                { label: '연금저축 가입 현황 확인', hint: '이미 가입했다면 납입액 파악' },
                { label: '작년 결정세액 확인', hint: '원천징수영수증 or 종합소득세 신고서' },
              ].map((item, idx) => (
                <li key={idx} style={{ padding: '12px 0', borderBottom: '1px solid var(--color-border-light)' }}>
                  <div style={{ fontWeight: '700', color: 'var(--color-brown-800)', marginBottom: '3px' }}>
                    ✓ {item.label}
                  </div>
                  <div style={{ fontSize: '12px', color: 'var(--color-text-muted)' }}>{item.hint}</div>
                </li>
              ))}
            </ul>
          </div>

          <div className="guide-card">
            <div className="guide-card-header guide-card-header--caramel">▶️ Step 2: 우선순위 실행</div>
            <div>
              {[
                { order: '1순위', title: 'ISA 가입', desc: '주식투자를 하고 있다면 무조건 ISA부터!', hint: '국내주식 매매차익 비과세 혜택' },
                { order: '2순위', title: '연금저축', desc: '세액공제가 필요하고 노후대비 의지가 있다면', hint: '연간 600만원 한도' },
                { order: '3순위', title: 'IRP 추가납입', desc: '연금저축 600만원 채우고도 여유가 있다면', hint: '연간 300만원 추가 한도' },
              ].map((item, idx) => (
                <div key={idx} style={{ padding: '14px 0', borderBottom: idx < 2 ? '1px solid var(--color-border-light)' : 'none' }}>
                  <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                    <span style={{
                      minWidth: '52px', padding: '4px 8px', borderRadius: 'var(--radius-pill)',
                      background: 'var(--color-brown-700)', color: '#fff', fontSize: '11px', fontWeight: '800', textAlign: 'center',
                    }}>
                      {item.order}
                    </span>
                    <div>
                      <div style={{ fontWeight: '800', color: 'var(--color-brown-800)', fontSize: '15px' }}>{item.title}</div>
                      <div style={{ fontSize: '13px', color: 'var(--color-text-sub)', marginTop: '2px' }}>{item.desc}</div>
                      <div style={{ fontSize: '12px', color: 'var(--color-text-muted)', marginTop: '2px' }}>{item.hint}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="lb-soft-panel lb-card-padded">
          <h3 className="lb-title-md" style={{ marginBottom: '16px' }}>🧮 납입액 결정 가이드</h3>
          <div className="lb-grid-2">
            <div className="lb-card lb-card-padded">
              <h4 style={{ fontSize: '15px', fontWeight: '800', color: 'var(--color-brown-800)', marginBottom: '8px' }}>
                ➕ 세금을 추가로 내는 경우
              </h4>
              <p style={{ fontSize: '13px', color: 'var(--color-text-sub)', marginBottom: '12px' }}>
                연말정산이나 종합소득세 신고 후 추가 납부하는 경우
              </p>
              <div className="lb-alert lb-alert-success" style={{ margin: 0 }}>
                <strong>추천:</strong> 연금저축 600만원 + IRP 300만원<br />
                <span style={{ fontSize: '12px' }}>세액공제 효과를 최대한 활용</span>
              </div>
            </div>
            <div className="lb-card lb-card-padded">
              <h4 style={{ fontSize: '15px', fontWeight: '800', color: 'var(--color-brown-800)', marginBottom: '8px' }}>
                ➖ 세금을 돌려받는 경우
              </h4>
              <p style={{ fontSize: '13px', color: 'var(--color-text-sub)', marginBottom: '12px' }}>
                연말정산 후 환급받는 경우
              </p>
              <div className="lb-alert lb-alert-info" style={{ margin: 0 }}>
                <strong>추천:</strong> 연금저축 600만원부터<br />
                <span style={{ fontSize: '12px' }}>중도인출이 상대적으로 쉬운 연금저축 우선</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    ),
  };

  return (
    <div>
      {/* Page hero */}
      <div className="lb-page-hero">
        <div className="lb-container">
          <p className="lb-eyebrow">Pension Guide</p>
          <h1 className="lb-title-lg">연금 완전 정복 가이드</h1>
          <p className="lb-body">연금 제도부터 절세 상품, 실전 가이드까지 — 노후 준비의 모든 것</p>
        </div>
      </div>

      <section className="lb-section">
        <div className="lb-container">

          {/* Tab bar */}
          <div className="lb-tabs">
            {tabs.map((tab) => (
              <button
                key={tab.key}
                className={`lb-tab${activeTab === tab.key ? ' lb-tab-active' : ''}`}
                onClick={() => setActiveTab(tab.key)}
              >
                {tab.label}
              </button>
            ))}
          </div>

          {/* Tab content */}
          <div className="lb-card lb-card-padded" style={{ marginBottom: '28px' }}>
            {tabContent[activeTab]}
          </div>

          {/* CTA */}
          <div className="lb-cta">
            <p className="lb-eyebrow-hand" style={{ marginBottom: '8px' }}>이론을 배웠다면 이제 계산해보세요</p>
            <h2 className="lb-title-md">본인 상황에 맞는 노후 계획을 세워보세요</h2>
            <div className="lb-cta-actions">
              <button className="lb-btn lb-btn-primary" onClick={() => onNavigate && onNavigate('forward')}>
                🧮 일반 계산기 사용하기
              </button>
              <button className="lb-btn lb-btn-outline" onClick={() => onNavigate && onNavigate('reverse')}>
                🎯 역산 계산기 사용하기
              </button>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
}

export default PensionGuide;
